<template>
    <div class="profile" v-if="userData" @click="showProfileActiveDo">
        <img :src="userData.photo | imgSrc" alt="" v-if="typeof userData.photo !== 'undefined' && userData.photo !== null && userData.photo">
        <img :src="env.public_base + '/assets/images/person-icon.png'" alt="" v-else>
        <span class="user-status is-online"></span>
        <p>{{ userData.last_name }} {{ userData.first_name }}</p>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import env from '../env';

    export default {
        data: () => ({
            env,
            profile_state: false
        }),
        computed: {
            ...mapGetters([
                'userData',
                'showProfileActive'
            ]),
        },
        methods: {
            showProfileActiveDo(){
                this.profile_state = !this.profile_state
                this.$store.dispatch('showProfileActive', this.profile_state);
            }
        },


    }
</script>
